import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'dedupeByProperty',
    pure: true,
    standalone: true
})
export class DedupeByPropertyPipe implements PipeTransform {
    transform(items: unknown, property?: string): any[] {
        if (!Array.isArray(items)) return [];
        if (!property) return items;

        const seen = new Set<any>();
        const result: any[] = [];

        for (const item of items) {
            const key = (item as any)?.[property];
            if (!seen.has(key)) {
                seen.add(key);
                result.push(item);
            }
        }

        return result;
    }
}
